import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import feedbackApi from "../../services/feedbackApi";
import handleAsyncThunk from "../handleAsyncThunk";
import { showSuccessSnackbar, showErrorSnackbar } from "./snackbarSlice";

export const submitUserFeedback = createAsyncThunk(
    "feedback/submitFeedback",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await feedbackApi.submitFeedback(data);
            if (response.status === 0) {
                dispatch(showSuccessSnackbar({ title: 'Feedback submitted successfully!' }));
                return response?.data;
            } else {
                dispatch(showErrorSnackbar({ title: response?.message || 'Failed to submit feedback' }));
                return rejectWithValue(response?.message);
            }
        } catch (error) {
            console.error(error);
            dispatch(showErrorSnackbar({ title: error?.message || 'An error occurred' }));
            return rejectWithValue(error.message);
        }
    }
);

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState: {
        isLoading: false,
        error: null,
        feedbackData: null
    },
    reducers: {},
    extraReducers: (builder) => {
        handleAsyncThunk(builder, submitUserFeedback, "feedbackData", "error", "isLoading");
    }
});

export default feedbackSlice.reducer;
